module.exports = __webpack_public_path__ + "static/media/iPhoneFrame.9688a16e.svg";